import React from 'react';
import { Box, Container, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import Header from '../Layouts/Header';
import Footer from '../Layouts/Footer';

const PageContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#FFFFFF'
}));

const ContentContainer = styled(Container)(({ theme }) => ({
  flex: 1,
  paddingTop: '60px',
  paddingBottom: '60px',
  maxWidth: '900px'
}));

const PageTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '36px',
  fontWeight: 700,
  color: '#1F2937',
  textAlign: 'center',
  marginBottom: '48px'
}));

const SectionText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '15px',
  fontWeight: 400,
  color: '#4B5563',
  lineHeight: '24px',
  marginBottom: '24px'
}));

const BulletList = styled('ul')(({ theme }) => ({
  margin: '12px 0 24px 0',
  paddingLeft: '24px',
  '& li': {
    fontFamily: 'Inter, sans-serif',
    fontSize: '15px',
    fontWeight: 400,
    color: '#4B5563',
    lineHeight: '24px',
    marginBottom: '12px'
  }
}));

const AttributionText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  color: '#6B7280',
  lineHeight: '22px',
  marginTop: '32px',
  fontStyle: 'italic'
}));

const DisclaimerPage = () => {
  return (
    <PageContainer>
      <Header />
      
      <ContentContainer>
        <PageTitle>Disclaimer</PageTitle>

        <Stack spacing={3}>
          <SectionText>
            Visibeen is an independent platform that uses third-party services and APIs, including but not limited to 
            Google Business Profile, Google Maps API, AWS, OpenAI (ChatGPT), Meta and others.
          </SectionText>

          <BulletList>
            <li>
              All trademarks, service marks, and logos of third parties remain the property of their respective owners. 
              Any such logos displayed on this website are used strictly for descriptive or referential purposes to 
              indicate technology integration and do not imply endorsement, sponsorship, or official partnership.
            </li>
          </BulletList>

          <SectionText>
            Visibeen uses AI technologies to generate insights, recommendations, and content. While we strive for accuracy, 
            we do not guarantee correctness, completeness, or suitability. Users are solely responsible for verifying AI 
            outputs before publishing or acting on them. Visibeen is not liable for any damages, errors, loss of reputation, 
            or compliance issues arising from reliance on AI-generated content.
          </SectionText>

          <SectionText>
            By activating a subscription or mandate, you authorize recurring payments as per your chosen plan. Payments are 
            generally non-refundable, except where explicitly required by law. Users must ensure valid payment credentials 
            for uninterrupted service.
          </SectionText>

          <SectionText>
            Visibeen disclaims all liability for:
          </SectionText>

          <BulletList>
            <li>Errors or inaccuracies in AI outputs</li>
            <li>Actions taken on third-party platforms (e.g., Google Business Profile)</li>
            <li>Service interruptions, data loss, or business losses resulting from API limitations, misuse, or external factors.</li>
          </BulletList>

          <AttributionText>
            Google and Google Maps are trademarks of Google LLC. All other trademarks mentioned are the property of 
            their respective owners. Use of these marks does not imply any affiliation with or endorsement by the 
            trademark holders.
          </AttributionText>
        </Stack>
      </ContentContainer>

      <Footer />
    </PageContainer>
  );
};

export default DisclaimerPage;
